import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "@/data/content";

export default function EditorialMarquee() {
  return (
    <section
      className="overflow-hidden border-y border-white/10 py-8"
      data-testid="marquee-section"
    >
      <Marquee speed={35} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item, i) => (
          <span key={item} className="flex items-center">
            <span
              className={`px-8 font-display text-4xl font-black uppercase tracking-tight md:text-6xl ${
                i % 2 === 0 ? "text-white" : "text-outline-dim"
              }`}
            >
              {item}
            </span>
            <span className="inline-block h-3 w-3 rotate-45 bg-[#0033FF]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
